define('part',[
	  'main_head'
	, 'main_navi'
	, 'main_link'
	, 'main_cell'
	, 'main_line'
	, 'main_nets'
	, 'main_info'
	, 'main_foot'
	, 'main_page'
	// , 'foot'
], function (
	  mainHead
	, mainNavi
	, mainLink
	, mainCell
	, mainLine
	, mainNets
	, mainInfo
	, mainFoot
	, mainPage
) {

	/*
	 * Tomando un manejador de objectos con todas las vistas parciales.
	**/
	return {
		  main_head: mainHead
		, main_navi: mainNavi
		, main_link: mainLink
		, main_cell: mainCell
		, main_line: mainLine
		, main_nets: mainNets
		, main_info: mainInfo
		, main_foot: mainFoot
		, main_page: mainPage
	};

});
